var React = require('react');

function Monument (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M384 464v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h352a16 16 0 0 1 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M289.14 100.74a32 32 0 0 0-9.21-19.44L203.31 4.69a16 16 0 0 0-22.63 0l-76.6 76.61a32 32 0 0 0-9.21 19.44L64 416h256zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8z","className":"fa-primary","key":2})]);
}

Monument.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Monument;

Monument.default = Monument;
